import { memo, ReactElement } from 'react';
import { AutocompleteInput, AutocompleteInputProps, ReferenceInput, ReferenceInputProps, SelectInput, SelectInputProps, useResourceContext } from 'react-admin';
import User from '../GeneratedModels/User';
import ReferenceQuickCreateInput from '../react-admin/ReferenceQuickCreateInput';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface UserSelectInputProps extends Omit<SelectInputProps, "optionText"> {
  optionText: 'id' | 'username' | 'password' | 'api_key' | 'email' | 'telephone' | 'mobile' | 'address_1' | 'address_2' | 'firebase_uid' | 'firebase_email' | 'firebase_phone' | 'role' | 'release' | 'expiry' | 'image_file' | 'image_filename' | 'image_filesize' | 'created' | 'createdBy' | 'updated' | 'updatedBy' | ((data: User) => string),
}

interface UserAutocompleteInputProps extends Omit<AutocompleteInputProps, "optionText"> {
  optionText: keyof User | ((data: User) => string),
  filterProps: Array<keyof User>,
}

interface UserReferenceInputProps extends Omit<ReferenceInputProps, 'source' | 'reference' | 'children'> {
  source?: string,
  reference?: string,
  selectInputProps?: UserSelectInputProps,
  autocompleteInputProps?: UserAutocompleteInputProps,
  filter?: Partial<User>,
  useAutocomplete?: boolean,

  quickCreate?: {
    fields?: ReactElement,
    formElements?: ReactElement,
  }
}

function UserReferenceInput({ label, source, reference, selectInputProps, useAutocomplete, autocompleteInputProps, quickCreate, validate, name, ...rest }: UserReferenceInputProps) {
  const resource = useResourceContext();
  label = label ?? `resources.${resource}.fields.${source}`
  return (
    quickCreate
      ? <ReferenceQuickCreateInput selectInputProps={selectInputProps as any} {...rest} {...quickCreate} source={source ?? "user_id"} reference={reference ?? "user"} />
      : <ReferenceInput {...rest} source={source ?? "user_id"} reference={reference ?? "user"} label={label}>
        {useAutocomplete && autocompleteInputProps
          ? <AutocompleteInput filterToQuery={q => ({ __mode: 'filterToQuery', ...(Object.fromEntries(autocompleteInputProps.filterProps.map(x => [x, q]))) })} {...autocompleteInputProps}/>
          : <SelectInput disabled={rest.disabled} {...selectInputProps} fullWidth validate={validate} name={name} label={label} />
        }
      </ReferenceInput>
  )
}

UserReferenceInput.defaultProps = {
  addLabel: true,
  fullWidth: true,
  // label: "User",
  source: "user_id",
  reference: "user",
  selectInputProps: {
    optionText: ((u: User) => u.username ? u.username : u.email ? u.email : u.firebase_phone ? u.firebase_phone : u.firebase_email as string),
  },
  autocompleteInputProps: {
    optionText: ((u: User) => u.username ? u.username : u.email ? u.email : u.firebase_phone ? u.firebase_phone : u.firebase_email as string),
    filterProps: [((u: User) => u.username ? u.username : u.email ? u.email : u.firebase_phone ? u.firebase_phone : u.firebase_email as string)],
  }
};

export default memo(UserReferenceInput);
